import { useTranslation } from 'react-i18next'
import Header from '../../../components/configurations/header'
import UserGroupsTable from '@components/configurations/users_config/user_groups/'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { MdPeopleAlt } from 'react-icons/md'
import { ProjectInfo } from '@models/projects.model'
import { Box } from '@mui/system'
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded'

export const UserGroups = () => {
	const { t } = useTranslation()

	const [userGroups, setUserGroups] = useState<any>([])
	const [project, setProject] = useState<ProjectInfo>()
	const navigate = useNavigate()

	return (
		<>
			<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
				<ArrowBackIosRoundedIcon
					fontSize={'large'}
					sx={{ cursor: 'pointer', color: '#707070' }}
					onClick={() => {
						navigate(`/configurations/users_config/user_groups/projects`)
					}}
				/>
				<Header
					title={t('Projects & Roles')}
					icon={<MdPeopleAlt style={{ fontSize: '35px', color: '#707070' }} />}
					userGroups={userGroups}
					project={project}
				/>
			</Box>

			<UserGroupsTable setProject={setProject} setUserGroups={setUserGroups} />
		</>
	)
}
